import { i18n } from '@zet/localization'
import { zetApi } from '@zet/network'

export async function fetchFields() {
  const currentLocale = i18n.locale

  const response = await zetApi.get(
    `/customer/getCriterialIndexes?locale=${currentLocale}`
  )
  return response.data
}
